import { Button, Checkbox } from "antd";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import useStyles from "../style";

const ChangeRoleModal = ({
  showModal,
  setShowModal,
  roles, // all available roles
  permissions, // all available permissions
  handleUpdateUserAccess,
  getAdminUsers
}) => {
  const styles = useStyles();
  const user = showModal; // The user object

  // State for the form
  const [selectedRoles, setSelectedRoles] = useState(user.roles?.map(r => r.name || r) || []);
  const [selectedPermissions, setSelectedPermissions] = useState(user.permissions?.map(p => p.name || p) || []);

  const [isSaving, setIsSaving] = useState(false);

  // Prepare options for Checkbox groups
  const roleOptions = roles.map(r => r.name || r);
  const permissionOptions = permissions.map(p => p.name);

  const handleSubmit = async () => {
    setIsSaving(true);

    const initialRoles = user.roles?.map(r => r.name || r) || [];
    const initialPermissions = user.permissions?.map(p => p.name || p) || [];

    // --- Calculate changes ---
    const rolesToAdd = selectedRoles.filter(r => !initialRoles.includes(r));
    const rolesToRemove = initialRoles.filter(r => !selectedRoles.includes(r));
    const permsToAdd = selectedPermissions.filter(p => !initialPermissions.includes(p));
    const permsToRemove = initialPermissions.filter(p => !selectedPermissions.includes(p));

    const success = await handleUpdateUserAccess({
      userId: user.userId,
      rolesToAdd,
      rolesToRemove,
      permsToAdd,
      permsToRemove
    });

    setIsSaving(false);

    if (success) {
      onHideModal();
    }
  };

  const onHideModal = () => {
    getAdminUsers(); // Refresh list
    setShowModal({ isVisible: false });
  };

  return (
    <Modal show={user.isVisible} onHide={onHideModal} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Manage Roles & Permissions</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        <p>User: <strong>{user.firstName} {user.lastName}</strong></p>
        <hr />
        
        <div className="row">
          <div className="col-md-6">
            <div className={styles.inputCont}>
              <div className={styles.inputLabel}>Roles</div>
              <Checkbox.Group
                options={roleOptions}
                value={selectedRoles}
                onChange={setSelectedRoles}
                style={{ display: 'flex', flexDirection: 'column' }}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className={styles.inputCont}>
              <div className={styles.inputLabel}>Permissions</div>
              <Checkbox.Group
                options={permissionOptions}
                value={selectedPermissions}
                onChange={setSelectedPermissions}
                style={{ display: 'flex', flexDirection: 'column' }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHideModal} disabled={isSaving}>
          Cancel
        </Button>
        <Button type="primary" onClick={handleSubmit} loading={isSaving}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangeRoleModal;
